import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from './../config/app_config';

export function* getOfferMetricsWatcherSaga() {
  yield takeLatest(types.GET_OFFER_METRICS, workerSaga);
}

export function fetchData() {
  const url = `${config.API_ROOT_URL}/v1/utils/kpis/`;

  return axios.get(url, {})
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga() {
  const response = yield call(fetchData);

  if (response && response.status === 200) {
    const { data } = response;
    yield put({ type: types.GET_OFFER_METRICS_SUCCESS, data });
  }
}
